<div class="modal-header" id="material-order-pricing-modal-title">
    <h3 class="modal-title">{{ strings.header }}</h3>
    <span class="close" (click)="!isLoading && modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <form [formGroup]="materialPricingForm">
        <fieldset formArrayName="formChildren" [disabled]="isLoading">
            <div class="container-fluid">
                <div class="row mb-3 form-container">
                    <label
                        class="col-12 col-lg-3 col-form-label text-start text-lg-end"
                        for="materialNo"
                        translate="MATERIAL_CUSTOMER_PRICING_LABEL_MATERIAL_NUMBER"
                    ></label>
                    <div class="col-12 col-lg-3">
                        <pace-core-text-input
                            id="materialNo"
                            name="materialNo"
                            [(model)]="model.materialNumber"
                            [parentForm]="materialPricingFormChildren"
                        ></pace-core-text-input>
                    </div>
                    <ng-container *ngIf="displayQuantityInput">
                        <label
                            class="col-12 col-lg-1 col-form-label text-start text-lg-end"
                            for="quantity"
                            translate="MATERIAL_CUSTOMER_PRICING_LABEL_QUANTITY"
                        ></label>
                        <div class="col-12 col-lg-3">
                            <pace-core-number-stepper
                                [(model)]="model.quantity"
                                name="quantity"
                                id="quantity"
                                [parentForm]="materialPricingFormChildren"
                            ></pace-core-number-stepper>
                        </div>
                    </ng-container>
                    <div class="col-2 mt-2 mt-lg-0">
                        <button
                            class="btn btn-primary float-lg-end"
                            (click)="addMaterial()"
                            translate="MATERIAL_CUSTOMER_PRICING_LABEL_BUTTON_ADD"
                            [disabled]="this.materialPricingForm.invalid"
                        ></button>
                    </div>
                </div>

                <div class="col-12">
                    <div class="row table-header fw-bold py-2">
                        <div class="col-1"></div>
                        <div class="col-3 offset-lg-1">
                            <span translate="MATERIAL_CUSTOMER_PRICING_TABLE_LABEL_MATERIAL"> </span>
                        </div>
                        <div class="col-2">
                            <span translate="MATERIAL_CUSTOMER_PRICING_TABLE_LABEL_STORAGE_LOCATION"> </span>
                        </div>
                        <div class="col-2">
                            <span translate="MATERIAL_CUSTOMER_PRICING_TABLE_LABEL_AVAILABLE"> </span>
                        </div>
                        <div class="col-3">
                            <div
                                *ngIf="displayCustomerPrice"
                                translate="MATERIAL_CUSTOMER_PRICING_TABLE_LABEL_PRICE"
                            ></div>
                            <div
                                *ngIf="displayRepairPrice"
                                translate="MATERIAL_CUSTOMER_PRICING_TABLE_LABEL_REPAIR_PRICE"
                            ></div>
                        </div>
                    </div>
                </div>

                <div class="table-row" *ngFor="let material of model.partSet.value; index as i">
                    <pace-material-pricing-details-expandable
                        [material]="material"
                        [index]="i"
                        [displayRepairPrice]="displayRepairPrice"
                        [displayCustomerPrice]="displayCustomerPrice"
                        [displayMaterialNotAvailable]="
                            material.available === 0 && isNgmAP0 && material.descTxt.length === 0
                        "
                        [displayTs]="displayTs"
                        [displayNdf]="displayNdf"
                        (materialDeletedEvent)="deleteMaterial($event)"
                    ></pace-material-pricing-details-expandable>
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <progressbar *ngIf="isLoading" [value]="100" type="default">Loading...</progressbar>
    <ng-container *ngIf="!isLoading">
        <div
            class="me-lg-auto flex-grow-1 flex-lg-grow-0 d-none d-lg-block"
            *ngIf="model.sparePartsCatalogLink"
            paceCoreLink
        >
            <a
                class="btn btn-primary pace-link w-100"
                href="{{ model.sparePartsCatalogLink }}"
                target="_blank"
                translate="SPARE_PARTS_CATALOG_LINK_LABEL"
            ></a>
        </div>

        <div class="d-lg-block d-none">
            <button
                class="btn btn-primary"
                [disabled]="!isNgmP58OrSA || model.partSet.value.length === 0"
                (click)="check()"
                translate="MATERIAL_CUSTOMER_PRICING_LABEL_BUTTON_CHECK"
            ></button>
            <button
                class="btn btn-primary mx-2"
                [disabled]="!isNgmP58OrSA || model.partSet.value.length === 0 || model.isMaterialRequested"
                (click)="order()"
                translate="MATERIAL_CUSTOMER_PRICING_LABEL_BUTTON_REQUEST"
            ></button>
            <button
                class="btn btn-primary"
                *ngIf="displayMaterialQuote"
                [disabled]="!isNgmP58OrSA || model.partSet.value.length === 0"
                (click)="createQuote()"
                translate="MATERIAL_CUSTOMER_PRICING_LABEL_BUTTON_CREATE_QUOTE"
            ></button>
        </div>

        <!-- Main Action button for mobile view -->
        <div class="d-lg-none d-block flex-grow-1">
            <a
                *ngIf="displaySparePartsLinkAsMainActionButton"
                class="btn btn-primary btn-lg pace-link w-100"
                href="{{ model.sparePartsCatalogLink }}"
                target="_blank"
                translate="SPARE_PARTS_CATALOG_LINK_LABEL"
            ></a>
            <button
                *ngIf="displayCheckAsMainActionButton"
                class="btn btn-primary btn-lg w-100"
                [disabled]="!isNgmP58OrSA || model.partSet.value.length === 0"
                (click)="check()"
                translate="MATERIAL_CUSTOMER_PRICING_LABEL_BUTTON_CHECK"
            ></button>
            <button
                class="btn btn-primary btn-lg w-100"
                *ngIf="displayRequestAsMainActionButton"
                [disabled]="!isNgmP58OrSA || model.partSet.value.length === 0 || model.isMaterialRequested"
                (click)="order()"
                translate="MATERIAL_CUSTOMER_PRICING_LABEL_BUTTON_REQUEST"
            ></button>
        </div>

        <div class="btn-group d-lg-none menu-container" dropdown [dropup]="true">
            <button
                id="button-toggler"
                dropdownToggle
                type="button"
                class="btn btn-secondary more-toggler btn-lg"
                aria-controls="dropdown-toggler"
            >
                <fa-icon [icon]="faEllipsisV"></fa-icon>
            </button>
            <ul
                id="dropdown-toggler"
                *dropdownMenu
                class="dropdown-menu dropdown-menu-right w-100"
                role="menu"
                aria-labelledby="button-toggler"
            >
                <li *ngIf="!displaySparePartsLinkAsMainActionButton" role="menuitem">
                    <button
                        class="btn btn-secondary btn-lg w-100 border-0"
                        *ngIf="model.sparePartsCatalogLink"
                        paceCoreLink
                    >
                        <a
                            href="{{ model.sparePartsCatalogLink }}"
                            target="_blank"
                            translate="SPARE_PARTS_CATALOG_LINK_LABEL"
                        ></a>
                    </button>
                </li>
                <li role="menuitem">
                    <button
                        *ngIf="!displayCheckAsMainActionButton"
                        class="btn btn-secondary btn-lg w-100"
                        [disabled]="!isNgmP58OrSA || model.partSet.value.length === 0"
                        (click)="check()"
                        translate="MATERIAL_CUSTOMER_PRICING_LABEL_BUTTON_CHECK"
                    ></button>
                </li>
                <li role="menuitem">
                    <button
                        *ngIf="!displayRequestAsMainActionButton"
                        class="btn btn-secondary btn-lg w-100 border-0"
                        [disabled]="!isNgmP58OrSA || model.partSet.value.length === 0 || model.isMaterialRequested"
                        (click)="order()"
                        translate="MATERIAL_CUSTOMER_PRICING_LABEL_BUTTON_REQUEST"
                    ></button>
                </li>
                <li role="menuitem">
                    <button
                        class="btn btn-secondary btn-lg w-100 border-0"
                        *ngIf="displayMaterialQuote"
                        [disabled]="!isNgmP58OrSA || model.partSet.value.length === 0"
                        (click)="createQuote()"
                        translate="MATERIAL_CUSTOMER_PRICING_LABEL_BUTTON_CREATE_QUOTE"
                    ></button>
                </li>
            </ul>
        </div>
    </ng-container>
</div>
